import { Box } from '@material-ui/core';
import LineItem from './LineItem';
import { useSelector } from 'react-redux';

const UnitSpecification = (props) => {
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    const leftPrice = parseFloat(
        parseFloat(props.left.price, 10) +
            parseFloat(props.left.price, 10) * process.env.REACT_APP_TAX_RATE
    ).toFixed(2);
    const rightPrice = parseFloat(
        parseFloat(props.right.price, 10) +
            parseFloat(props.right.price, 10) * process.env.REACT_APP_TAX_RATE
    ).toFixed(2);
    const left = props.leftType
        ? `L - ${props.leftType} ${props.left.displayName}`
        : `L - ${props.left.displayName}`;
    const right = props.rightType
        ? `R - ${props.rightType} ${props.right.displayName}`
        : `R - ${props.right.displayName}`;
    return (
        <>
            <Box style={{ width: '100%', paddingBottom: '10px' }}>
                <LineItem title={props.title} value={left} price={currency + leftPrice} />
                <LineItem title="" value={right} price={currency + rightPrice} />
            </Box>
        </>
    );
};

export default UnitSpecification;
